import React, { FC } from "react";
import Svg, { Polygon, SvgProps } from "react-native-svg";

export interface ICustomSvgProps extends SvgProps {
    strokeColor?: string;
}

const CancelIcon: FC<ICustomSvgProps> = (props) => {
    return (
        <Svg
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 512 512"
            fill={props.strokeColor || "#000000"}
            {...props}
        >
            <Polygon points="512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 512,452.922 315.076,256" />
        </Svg>
    );
};

export default CancelIcon;
